module.exports = __webpack_public_path__ + "static/forest-bathing-7710ace56b3c472801d7de96c589310b.jpg";